import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const base = `/${IGCData.routeBase || ''}`;

export default new Router({
  mode: 'history',
  base,
  routes: [
    {
      path: '/draft',
      name: 'draft',
      component: () => import(/* webpackChunkName: 'draft' */ '@/views/Draft/draft.vue')
    },
    {
      path: '/selectAddress',
      name: 'selectAddress',
      component: () => import('@/views/selectAddress/index.vue')
    },
    {
      path: '/newYear2021UnGet',
      name: '跨年活动未领取页',
      component: () => import('@/views/newYear2021/indexUnGet')
    },
    {
      path: '/newYear2021get',
      name: '跨年活动已领取页',
      component: () => import('@/views/newYear2021/indexGet')
    },
    {
      path: '/redPacketGame',
      name: '红包雨游戏页',
      component: () => import('@/views/bonusRain/gameNew')
    },
    {
      path: '/redPacketIndex',
      name: '红包雨活动页',
      component: () => import('@/views/bonusRain/index')
    }, {
      path: '/challenge',
      name: '挑战赛',
      component: () => import('@/views/challenge')
    }, {
      path: '/squareSubject',
      name: '活动广场话题页',
      component: () => import('@/views/square/subject.vue')
    }, {
      path: '/squareMindDetails',
      name: '话题广场想法详情页',
      component: () => import('@/views/square/mindDetails.vue')
    }, {
      path: '/squareMySends',
      name: '话题广场我发布的想法页',
      component: () => import('@/views/square/mySends.vue')
    }, {
      path: '/squareRules',
      name: '话题广场我发布的公约',
      component: () => import('@/views/square/squareRules.vue')
    }, {
      path: '/test',
      name: 'test',
      component: () => import('@/views/test.vue')
    }, {
      path: '/audioDemo',
      name: 'audioDemo',
      component: () => import('@/views/audioDemo.vue')
    }, {
      path: '/childrenDay',
      name: '六一活动',
      component: () => import('@/views/childrenDay/index')
    },
    {
      path: '/childrenDayNew',
      name: '六一活动·新',
      component: () => import('@/views/childrenDayNew/index')
    },
    {
      path: '/activityTask',
      name: '活动任务',
      component: () => import('@/views/childrenDayNew/activityTask')
    },
    {
      path: '/SpringFestival',
      name: '春节活动',
      component: () => import('@/views/SpringFestival/index')
    },
    {
      path: '/yearReport',
      name: '年终报告',
      component: () => import('@/views/2024yearReport/index')
    },
    {
      path: '/yearReportReview',
      name: '年终报告领取落地页',
      component: () => import('@/views/2024yearReport/review')
    },
    {
      path: '/midYearReport',
      name: '年中报告',
      component: () => import('@/views/midYearReport/index')
    },
    {
      path: '/prizeList',
      name: '奖品商店',
      component: () => import('@/views/cashPrize/prizeList')
    },
    {
      path: '/cashPrizeList',
      name: '兑换记录',
      component: () => import('@/views/cashPrize/cashPrizeList')
    },
    {
      path: '/cashEntity',
      name: '兑换实物',
      component: () => import('@/views/cashPrize/cashEntity')
    },
    {
      path: '/squarePage',
      name: '广场聚合页',
      component: () => import('@/views/squarePage/index'),
    },
    {
      path: '/squarePageLive',
      name: '广场聚合页-素养卡片',
      component: () => import('@/views/squarePage/indexLive.vue'),
    },
    {
      path: '/squarePageTraining',
      name: '广场聚合页-阅读营首页',
      component: () => import('@/views/squarePage/indexTraining.vue'),
    },
    {
      path: '/releaseTopic',
      name: '发布话题',
      component: () => import('@/views/squarePage/releaseTopic')
    },
    {
      path: '/weeklyDutyMap/',
      name: '训练营每周任务地图解锁',
      component: () => import('@/views/Dash'),
      children: [
        {
          name: '训练营每周任务地图解锁首页',
          path: 'index',
          component: () => import('@/views/weeklyDutyMap/index.vue')
        }
      ]
    },
    {
      path: '/card',
      name: '我的卡片',
      component: () => import('@/views/card/index')
    },
    {
      path: '/chess',
      name: '国际象棋',
      component: () => import('@/views/chess/index')
    },
    {
      path: '/chessHomework',
      name: '国际象棋练习',
      component: () => import('@/views/chessHomework/index')
    },
    {
      path: '/chessFight',
      name: '国际象棋对战',
      component: () => import('@/views/chessFight/index')
    },
    {
      path: '/ChineseChess',
      name: '中国象棋',
      component: () => import('@/views/ChineseChess/index')
    },
    {
      path: '/ChineseChessHomework',
      name: '中国象棋练习',
      component: () => import('@/views/ChineseChessHomework/index')
    },
    {
      path: '/ChineseChessFight',
      name: '中国象棋对战',
      component: () => import('@/views/ChineseChessFight/index')
    },
    {
      path: '/strollingBarrage',
      name: '逛逛弹幕',
      component: () => import('@/views/strollingBarrage/index')
    },
    {
      path: '/monopolyRewardList',
      name: '奖励记录', // 大富翁地图奖励记录
      component: () => import('@/views/monopoly/rewardList')
    },
    {
      path: '/sawPuzzle',
      name: '拼图游戏',
      component: () => import('@/views/sawPuzzle/index')
    },
    {
      path: '/checkInReceivePrizes',
      name: '打卡领实物',
      component: () => import('@/views/checkInReceivePrizes/index')
    },
    {
      path: '/ferruleHome',
      name: '套圈首页',
      component: () => import('@/views/ferrule/index')
    },
    {
      path: '/ferruleDarwList',
      name: '套圈奖品页',
      component: () => import('@/views/ferrule/darwList')
    },
    {
      path: '/ferruleGame',
      name: '游戏页',
      component: () => import('@/views/ferrule/ferruleGame')
    },
    // 植树节种植start
    {
      path: '/energyRanking',
      name: '植树节能量排行榜',
      component: () => import('@/views/treePlanting/energyRanking')
    },
    {
      path: '/myHarvest',
      name: '植树节我的收获',
      component: () => import('@/views/treePlanting/myHarvest')
    },
    {
      path: '/publicity',
      name: '植树节公示页',
      component: () => import('@/views/treePlanting/publicity')
    },
    {
      path: '/treeReview',
      name: '植树节邀请页',
      component: () => import('@/views/treePlanting/review')
    },
    // 植树节种植end
    {
      path: '/pkAnswer',
      name: '答题PK',
      component: () => import('@/views/pkAnswer/index')
    },
    {
      path: '/pkAnswerRanking',
      name: '答题PK小红花排行榜',
      component: () => import('@/views/pkAnswer/rankingList')
    },
    {
      path: '/pkAnswerRecord',
      name: '答题PK小红花记录',
      component: () => import('@/views/pkAnswer/flowerRecord')
    },
    {
      path: '/pkAnswerShop',
      name: '答题PK小红花商店',
      component: () => import('@/views/pkAnswer/shopList')
    },
    {
      path: '/pkAnswerShopDetail',
      name: '答题PK小红花商店详情',
      component: () => import('@/views/pkAnswer/shopDetail')
    },
    {
      path: '/pkAnswerShopResult',
      name: '答题PK小红花商店结果',
      component: () => import('@/views/pkAnswer/shopResult')
    },
    {
      path: '/userCare',
      name: '用户关怀',
      component: () => import('@/views/userCare/index')
    },
    {
      path: '/learnRanking',
      name: '学习排行榜',
      component: () => import('@/views/learnRanking/index')
    },
    {
      path: '/historyLearnRanking',
      name: '学习排行榜',
      component: () => import('@/views/learnRanking/history')
    },
    {
      path: '/worryMailboxReply', // 回信
      name: '烦恼信箱',
      component: () => import('@/views/worryMailbox/replay')
    },
    {
      path: '/worryMailboxIncoming', // 来信
      name: '烦恼信箱',
      component: () => import('@/views/worryMailbox/incoming')
    }
  ]
});
